import L from "leaflet";

export const MAP_URL = "https://www.onemap.gov.sg/maps/tiles/Default/{z}/{x}/{y}.png";
export const MAP_CENTER = L.bounds([
  [1.49, 104.135],
  [1.14, 103.6],
]).getCenter(); // Center point for the map

export const SOUTH_WEST = L.latLng(1.49, 104.135), // This help to set South West View North East Coordinates
  NORTH_EAST = L.latLng(1.14, 103.6), // This help to set North East Coordinates    IMPORTANT TO SET BOUNDS ON MAP
  MAP_BOUNDS = L.latLngBounds(SOUTH_WEST, NORTH_EAST);

export let ATTRIBUTION_CONTROL =
'<img src="https://www.onemap.gov.sg/web-assets/images/logo/om_logo.png" class="map-onemap-logo"  /> \
OneMap | Map data &copy; contributors, <a href="http://SLA.gov.sg">Singapore Land Authority</a>';
export const MAX_ZOOM_ALLOWED = 19;
export const MIN_ZOOM_ALLOWED = 12;
export const ZOOM_TO_LEVEL = 19;
export const SEARCH_ONE_MAP_API =
  "https://www.onemap.gov.sg/api/common/elastic/search?returnGeom=Y&getAddrDetails=Y&pageNum=1&searchVal=";

export const PLUGIN_OPTIONS = {
  cropImageByInnerWH: true,
  hidden: true,
  preventDownload: false, // prevent download on button click
  domtoimageOptions: {}, // see options for dom-to-image
  position: "topright", // position of take screen icon
  screenName: "CAAS_Licence_Map_Screenshot", // Name for DownLoaded file
  hideElementsWithSelectors: [".leaflet-control-container"], // by default hide map controls All els must be child of _map._container
  mimeType: "image/png", // used if format == image,
  caption: null, // string or function, added caption to bottom of screen
  captionFontSize: 15,
  captionFont: "Arial",
  captionColor: "black",
  captionBgColor: "white",
  captionOffset: 5,
  onPixelDataFail: async function ({
    node,
    plugin,
    error,
    mapPane,
    domtoimageOptions,
  }) {
    return plugin._getPixelDataOfNormalMap(domtoimageOptions);
  },
};
export const AREA_LIMIT_SQUARE_METERS=50000;